import React from "react";
import {Container} from "react-bootstrap";
import Jan152023MlkDayAmphisbaenae from "./blog/Jan152023MlkDayAmphisbaenae";
import ChillFogLights from "./translations/qinguan/ChillFogLights";
import LordOfTheCenter from "./translations/zhuangzi/LordOfTheCenter";
import HorsesHooves from "./translations/zhuangzi/HorsesHooves";
import TheLifecycleOfSoftwareObjects from "./reading/chiang/TheLifecycleOfSoftwareObjects";

function Home() {
    return (
        <Container>
            <TheLifecycleOfSoftwareObjects/>
            <hr/>
            <Jan152023MlkDayAmphisbaenae/>
            <hr/>
            <ChillFogLights/>
            <hr/>
            <LordOfTheCenter/>
            <hr/>
            <HorsesHooves/>
        </Container>
    );
}

export default Home;
